export default {
  base: {
    look: ["look", null],
  },
  move: {
    up: ["move", { x: 0, y: -1 }],
    left: ["move", { x: -1, y: 0 }],
    right: ["move", { x: 1, y: 0 }],
    down: ["move", { x: 0, y: 1 }],
    mouseTile: ["mouseTileMove", null],
    sUp: ["sprint", { x: 0, y: -1 }],
    sLeft: ["sprint", { x: -1, y: 0 }],
    sRight: ["sprint", { x: 1, y: 0 }],
    sDown: ["sprint", { x: 0, y: 1 }],
  },
  focusMove: {
    up: ["focusMove", { x: 0, y: -1 }],
    left: ["focusMove", { x: -1, y: 0 }],
    right: ["focusMove", { x: 1, y: 0 }],
    down: ["focusMove", { x: 0, y: 1 }],
    mouseTile: ["mouseTileMove", null],
  },
  playerActions: {
    cheat: ["cheat", null],
    wait: ["wait", null],
  },
} as const;
